import React from 'react';
import {
  FooterWrapper,
  FooterContent,
  FooterImageWrapper,
  FooterLinks,
  FooterLinkWrapper,
  FooterLink,
  DetailsWrapper,
  FooterDisclaimer,
  FooterDisclaimerItem,
  FooterLogo,
} from './partialStyles';

const Footer = React.memo(() => (
  <FooterWrapper>
    <FooterContent>
      <FooterImageWrapper>
        <FooterLogo />
      </FooterImageWrapper>
      <DetailsWrapper>
        <FooterLinks>
          <FooterLinkWrapper>
            For Terms and Conditions please visit{' '}
            <FooterLink href="https://www.boots.com" target="_blank">
              boots.com
            </FooterLink>
          </FooterLinkWrapper>
          <FooterLinkWrapper>
            <FooterLink href="https://www.boots.com/privacypolicy" target="_blank">
              Privacy Policy
            </FooterLink>
          </FooterLinkWrapper>
        </FooterLinks>
        <FooterDisclaimer>
          <FooterDisclaimerItem>
            <strong>Please note:</strong> Food supplements do not replace the need for a varied and healthy diet.
          </FooterDisclaimerItem>
          <FooterDisclaimerItem>
            Copyright © The Boots Company PLC. All rights reserved. Boots.com is a trading name of Boots UK Limited.
            Registered office: Nottingham NG2 3AA.Registered in England: company number 928555. Registered VAT number
            116300129. For details of Boots online pharmacy services see Using Our Pharmacy Services page. Read more at
            boots.com
          </FooterDisclaimerItem>
        </FooterDisclaimer>
      </DetailsWrapper>
    </FooterContent>
  </FooterWrapper>
));

export default Footer;
